import { IBase } from "./Base";

export interface ICorporateValues extends IBase {
  title: string;
  avatar?: string;
  description: string;
  vendorId: string;
  deleted: boolean;
  timesSent?: number;
}

export enum ERecognitionType {
  SENDING = "SENDING",
  RECEIVING = "RECEIVING",
}
